<!--字典表-->
<template>
	<div class="newenumsetting">
		 <div class="con">
			  <div class="set-left">
						<div class="set-title-top">
							<span class="set-title">字典定义</span>
							<!-- <el-button type="primary" size="mini"  @click="addEnum">新增</el-button> -->
							<el-button type="primary" size="mini"  @click="add_ed">新增</el-button>
						</div>
						<el-scrollbar style="height:92%;width: 100%;">
							<div :class="['item',{'active':item.id == itemActive}]" v-for="(item,index) in enumTree" :key="item.id" @click="checkItem(item)">
								<div class="name" style="font-size:14px">{{index +1}}.{{item.enumname}}</div>
							</div>
						</el-scrollbar>
			  </div>
			  <div class="right-table">
				   <div class="top-table">
					   <div class="Files-top">
							<div class="ic-left">
							<span>字典详情</span>
							</div>
							<div class="btns"></div>
						</div>
						<el-table :data="newnowEnum" stripe height="90" style="width: 100%;margin-top: 20px;" border>
                        <template slot="empty">
                          <span class="noData">
                            <img src="@/assets/noData.png" alt="暂无数据">
                            <span class="text">暂无数据</span>
                          </span>
                        </template>
                        <el-table-column type="index" label="序号" width="90" align="center">
                        </el-table-column>
                        <el-table-column prop="id" label="字典编码" >
                        </el-table-column>
                        <el-table-column prop="enumname" label="字典名称">
                        </el-table-column>
                        <el-table-column prop="editable" label="是否可编辑"  align="center">
							   <template #default="{row}">
								    <span v-if="row.editable == 1">是</span>
								    <span v-else>否</span>
								</template>
                        </el-table-column>
                        <el-table-column label="操作" width='250'  align="center" fixed="right">
                            <template #default="{row}">
                              <div class="public-flex">
                                    <div @click="edit_ed(row)" class="mr-20">
                                      <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                                        <elIconBtn btnType='edit'></elIconBtn>
                                      </el-tooltip>
                                    </div>
                                    <div @click="del_fn(row)">
                                      <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                        <elIconBtn btnType='del'></elIconBtn>
                                      </el-tooltip>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                      </el-table>

				   </div>
				   <div class="bot-table">
					    <div class="Files-top">
							<div class="ic-left">
							<span>字典项列表</span>
							</div>
							<div class="btns">
								 <el-button type="primary"  @click="myadd_ed" class="last-el-button">添加字典项</el-button>
							</div>
						</div>
						<el-table :data="nowEnum.next" :height="heights" stripe  style="width: 100%;margin-top: 20px;" border>
							<template slot="empty">
							<span class="noData">
								<img src="@/assets/noData.png" alt="暂无数据">
								<span class="text">暂无数据</span>
							</span>
							</template>
							<el-table-column type="index" label="序号" width="90" align="center">
							</el-table-column>
							<el-table-column prop="itemText" label="字典名称" min-width="200">
							</el-table-column>
							<el-table-column prop="itemValue" label="值" min-width="150">
							</el-table-column>
							<el-table-column prop="editable" label="是否可编辑"  align="center" min-width="100">
								<template #default="{row}">
										<span v-if="row.editable == 1">是</span>
										<span v-else>否</span>
									</template>
							</el-table-column>
							<el-table-column label="创建时间" min-width="240">
								<template slot-scope="scope"><span>{{ scope.row.createTime | date_format}}</span></template>
							</el-table-column>
							<el-table-column label="操作" width='250'  align="center" fixed="right">
								<template #default="{row}">
								<div class="public-flex">
										<div @click="myedit_ed(row)" class="mr-20">
										<el-tooltip class="item" effect="dark" content="编辑" placement="top">
											<elIconBtn btnType='edit'></elIconBtn>
										</el-tooltip>
										</div>
										<div @click="deleteEnumItem(row)">
										<el-tooltip class="item" effect="dark" content="删除" placement="top">
											<elIconBtn btnType='del'></elIconBtn>
										</el-tooltip>
										</div>
									</div>
								</template>
							</el-table-column>
						</el-table>
				   </div>
			  </div>
		
		 </div>
		  <!-- 字典详情 -->
		    <el-dialog  v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
                  :visible.sync="dialogVisible">
                  <div style="display: flex;" class="newinput">
                    <el-form :model="temp" ref="temp" :rules="rules" style="width: 80%;height: 120px;padding-top: 10px;">
                      <el-form-item label="字典名称:" prop="enumname">
                        <el-input v-model="temp.enumname" style=""></el-input>
                      </el-form-item>

                      <el-form-item label="字典编码:"  prop="enumcode">
                        <el-input v-model="temp.enumcode" :disabled='dialogStatus=="edit"'></el-input>
                      </el-form-item>

                    </el-form>
                  </div>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定</el-button>
                  </div>
           </el-dialog>
          <!-- 字典项列表 -->
		   <el-dialog  v-dialogDrag :title="mytextMap[mydialogStatus]" :close-on-click-modal='false'
                  :visible.sync="mydialogVisible">
                  <div style="display: flex;" class="newinput">
                    <el-form :model="mytemp" ref="mytemp" :rules="rules" style="width: 80%;height: 120px;padding-top: 10px;">
                      <el-form-item label="项名称：" prop="itemText">
                        <el-input v-model="mytemp.itemText" style="" placeholder="请输入字典项名称"></el-input>
                      </el-form-item>

                      <el-form-item label="项值："  prop="itemValue">
                        <el-input v-model="mytemp.itemValue"  placeholder="请输入字典的值"></el-input>
                      </el-form-item>

                    </el-form>
                  </div>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="mydialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="mydialogStatus==='edit'?editEnumItem('mytemp'):addEnumItem('mytemp')">确 定</el-button>
                  </div>
           </el-dialog>
	</div>
</template>

<script>
import nomalInputDialog from '@/components/module/dialog/nomalInputDialog.vue'
import elIconBtn from '@/components/module/iconBtns.vue'
import infoList from '@/components/module/universal/infoList.vue'
	export default {
		components: {
        nomalInputDialog,
        infoList,
		elIconBtn
		},
		props: [],
		data() {
			return {
				heights: document.getElementById('app').clientHeight-430,
                itemActive:"dydj",
				nowEnum: {},
				newnowEnum: [],
				nowIndex:0,
				nowEnumItem: undefined,
				EnumColumns: [{//驼峰没改
					name: '字典编码',
					key: 'enumcode',
				}, {
					name: '字典名称',
					key: 'enumname',
				}, {
					name: '是否允许编辑', 
					key: 'editable',
					format(value){
						return value == 1? "是" : "否"
					}
				}, {
					name: '创建时间',
					key: 'createTime',
					format(value){
						if (isempty(value)) {
							return ''
						}
						return new Date(value).formatByTime()
					}
				}],
				EnumItemColumns: [{
					name: '字典项名称', 
					key: 'itemText',
				}, {    
					name: '值',
					key: 'itemValue',
				}, {
					name: '是否允许编辑',
					key: 'editable',
					format(value){
						return value == 1? "是" : "否"
					}
				}, {
					name: '创建时间',
					key: 'createTime',
					format(value){
						if (isempty(value)) {
							return ''
						}
						return new Date(value).formatByTime()
					}
				}],
				  textMap: {
					add: "新增字典",
					edit: "编辑字典"
					},
			    rules: {
					enumname: [
						{required: true,message: '请输入字典名称',trigger: 'blur'}
					],
					enumcode: [
						{required: true,message: '请输入字典编码',trigger: 'blur'}
					],
					itemText: [
						{required: true,message: '请输入字典项名称',trigger: 'blur'}
					],
					itemValue: [
						{required: true,message: '请输入字典项的值',trigger: 'blur'}
					],
				},
				temp: {},
				dialogVisible: false,
				dialogStatus: '',


				 mytextMap: {
					add: "新增字典项",
					edit: "编辑字典项"
					},
				mydialogVisible:false,
				mydialogStatus:"",
				mytemp: {},
				
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
            if(this.enumTree.length != 0){
                  this.checkItem(this.enumTree[0])
                }
        },
		destroyed() {},
		computed: {
			enumTree() { 
                var tree = this.$store.enumStore.getters.getEnumTree
				return tree
			},
			EnumInfo() {
				return [copy(this.nowEnum)]
			},
			EnumItemInfo() {
				if(isempty(this.nowEnum.next)) {
					return []
				}
				return copy(this.nowEnum.next)
			},
			showEnumItemInfo(){
				var datas = this.EnumItemInfo
				var index = this.nowIndex*20
				var limit = index+20
				datas =  datas.filter((d,i)=>{
					return   i<limit && i>=index
				})
				return  datas.sort((a,b)=>{
					return b.createTime - a.createTime
				})
			}
		},
		watch: {},
		methods: {
            checkItem(item){
               this.nowEnum =  item
			   this.newnowEnum = [item]
			   console.log("newnowEnum",item);
               this.itemActive = item.id
               this.nowEnumItem = undefined
               //    this.$refs.EnumItemList.nowCheckIndex = -1
            },
			 // 添加弹窗
			add_ed () {
				this.dialogStatus='add';
				this.dialogVisible=true;
				this.$nextTick(() => {
				this.$refs["temp"].clearValidate();
				});
				this.temp={};
			},
			// 确认添加
			add_fn (formName) {
				this.$refs[formName].validate(valid => {

				if(valid) {
					this.$api.enumApi.addEnum(this.temp.enumcode, this.temp.enumname, '', respon => {
						 this.$message({showClose: true,message: '添加成功',type: 'success'});
						this.$store.enumStore.state.enumTree.push(respon)
						this.dialogVisible=false;
					}, respon => {
						 respon ? this.$message.error(respon) : this.$message.error("添加失败")
					})

				} else {
					return false;
				}
				});
			},
			// 确认编辑
			edit_fn (formName) {
				this.$refs[formName].validate(valid => {
				if(valid) {
					this.$api.enumApi.updateEnum(this.temp.enumcode, this.temp.enumname, '', respon => {
						 this.$message({showClose: true,message: '修改成功',type: 'success'});
						// this.nowEnum.enumname = item.enumName
						let index = this.enumTree.findIndex(item => item.id == this.itemActive)
						this.newnowEnum[0].enumname = this.temp.enumname
						this.dialogVisible=false;
					}, respon => {
						 respon ? this.$message.error(respon) : this.$message.error("修改失败")
					})

				} else {
					return false;
				}
				});
			},
			//编辑弹窗
			edit_ed (v) {
				if(v.editable===0){
					 this.$message({showClose: true,message: '当前字典不允许编辑!',type: 'warning'});
					return
				}
				this.dialogStatus="edit";
				this.temp=Object.assign({},v);
				this.dialogVisible=true;
				this.$nextTick(() => {
				this.$refs["temp"].clearValidate();
				});
			},
			//删除字典
			del_fn (row) {
					if(row.editable===0){
						this.$message({showClose: true,message: '当前字典项不允许编辑!',type: 'warning'});
						return
					}
					this.$confirm(`是否删除 ${row.enumname} 及相关属性?`,'提示',{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
					}).then(() => {
						this.$api.enumApi.deleteEnum(row.enumcode, respon => {
							 this.$message({showClose: true,message: '删除字典成功!',type: 'success'});
							this.$store.enumStore.state.enumTree = this.$store.enumStore.state.enumTree.filter(item => {
								return item.enumcode != row.enumcode
							})
							this.newnowEnum = []
							// this.$refs.EnumList.nowCheckIndex = -1
							// this.$refs.enumTreeBean.checkItem(this.$store.enumStore.state.enumTree[0])//删除之后重新点击下当前树存在的第一个可用节点以刷新删除掉的页面
							
						}, respon => {
							 respon ? this.$message.error(respon) : this.$message.error("删除失败")
						})
					}).catch(() => {
					// ...
					});
			},

			myadd_ed(){
				this.mydialogStatus='add';
				this.mydialogVisible=true;
				this.$nextTick(() => {
				this.$refs["mytemp"].clearValidate();
				});
				this.mytemp={};
			},
			myedit_ed(v){
				if(v.editable===0){
					 this.$message({showClose: true,message: '当前字典项不允许编辑!',type: 'warning'});
					return
				}
				this.mydialogStatus="edit";
				this.mytemp=Object.assign({},v);
				this.mydialogVisible=true;
				this.$nextTick(() => {
				this.$refs["mytemp"].clearValidate();
				});
			},
			
			addEnumItem(formName) {
				if(this.nowEnum.editable===0){
					 this.$message({showClose: true,message: '当前字典项不允许编辑!',type: 'warning'});
					return
				}

				this.$refs[formName].validate(valid => {
				if(valid) {
					this.$api.enumApi.addEnumItem(this.nowEnum.enumcode, this.mytemp.itemText, this.mytemp.itemValue, '', respon => {
						 this.$message({showClose: true,message: '添加成功',type: 'success'});
						this.nowEnum.next.push(respon)
						this.mydialogVisible=false;
					}, respon => {
						 respon ? this.$message.error(respon) : this.$message.error("添加失败")
					})

				} else {
					return false;
				}
				});


				//旧方法
				// var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				// dialog.open('添加字典项', [{
				// 	name: '名称',
				// 	pkid: 'itemText',
				// }, {
				// 	name: '值',
				// 	pkid: 'itemValue',
				// }], item => {
				// 	if(isempty(item.itemText)){
				// 		this.$dialogMethod.showMessage("名称不能为空!")
				// 		return false
				// 	}
				// 	if(isempty(item.itemValue)){
				// 		this.$dialogMethod.showMessage("值不能为空!")
				// 		return false
				// 	}
				// 	//计算序号
				// 	var sort = 0
				// 	if(!isempty(this.EnumItemInfo)) {
				// 		sort = this.EnumItemInfo[this.EnumItemInfo.length - 1].sort + 1
				// 	}
				// 	this.$api.enumApi.addEnumItem(this.nowEnum.enumcode, item.itemText, item.itemValue, sort, respon => {
				// 		this.$dialogMethod.showMessage("添加字典项成功!")
				// 		this.nowEnum.next.push(respon)
				// 	}, respon => {
				// 		this.$dialogMethod.showMessage(respon)
				// 	})
				// })
			},
			deleteEnumItem(row) {
				if(row.editable===0){
						this.$message({showClose: true,message: '当前字典项不允许编辑!',type: 'warning'});
						return
				  }
				this.$confirm(`是否删除字典项 ${row.itemText} ?`,'提示',{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
					}).then(() => {
						this.$api.enumApi.deleteEnumItem(row.pkid, respon => {
							 this.$message({showClose: true,message: '删除字典项成功!',type: 'success'});
							 this.$dialogMethod.showMessage("删除字典项成功!")
								this.nowEnum.next = this.nowEnum.next.filter(item => {
									return item.pkid != row.pkid
								})
							// this.$refs.EnumList.nowCheckIndex = -1
							// this.$refs.enumTreeBean.checkItem(this.$store.enumStore.state.enumTree[0])//删除之后重新点击下当前树存在的第一个可用节点以刷新删除掉的页面
							
						}, respon => {
							 respon ? this.$message.error(respon) : this.$message.error("删除失败")
						})
					}).catch(() => {
					// ...
					});
				return
				if(this.nowEnum.editable===0){
					this.$dialogMethod.showMessage("当前字典项不允许编辑!")
					return
				}
				if(this.nowEnumItem == undefined) {
					this.$dialogMethod.showMessage("请先选中要删除的字典项!")
					return
				}
				this.$dialogMethod.openAgreeDialog('删除字典项', "是否删除字典项 " + this.nowEnumItem.itemText + "?", () => {
					this.$api.enumApi.deleteEnumItem(this.nowEnumItem.pkid, respon => {
						this.$dialogMethod.showMessage("删除字典项成功!")
						this.nowEnum.next = this.nowEnum.next.filter(item => {
							return item.pkid != this.nowEnumItem.pkid
						})
						this.nowEnumItem = undefined
						this.$refs.EnumItemList.nowCheckIndex = -1
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			editEnumItem(formName) {
                
				this.$refs[formName].validate(valid => {
				if(valid) {
					this.$api.enumApi.updateEnumItem(this.mytemp.pkid, this.mytemp.itemText, this.mytemp.itemValue, this.mytemp.sort, respon => {
						this.$message({showClose: true,message: '修改成功',type: 'success'});
						var enumitem = this.nowEnum.next.find(it => {
							return it.pkid == this.mytemp.pkid
						})
						enumitem.itemText = this.mytemp.itemText
						enumitem.itemValue = this.mytemp.itemValue
						this.mydialogVisible=false;
					}, respon => {
						// this.$dialogMethod.showMessage(respon)
						 respon ? this.$message.error(respon) : this.$message.error("添加失败")
					})

				} else {
					return false;
				}
				});

				return

				if(this.nowEnum.editable===0){
					this.$dialogMethod.showMessage("当前字典项不允许编辑!")
					return
				}
				if(this.nowEnumItem == undefined) {
					this.$dialogMethod.showMessage("请先选中要删除的字典项!")
					return
				}
				
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('编辑字典项', [{
					name: '名称',
					pkid: 'itemText',
					defaultValue:this.nowEnumItem.itemText
				}, {
					name: '值',
					pkid: 'itemValue',
					defaultValue:this.nowEnumItem.itemValue
				}], item => {
					if(isempty(item.itemText)){
						this.$dialogMethod.showMessage("名称不能为空!")
						return false
					}
					if(isempty(item.itemValue)){
						this.$dialogMethod.showMessage("值不能为空!")
						return false
					}
					this.$api.enumApi.updateEnumItem(this.nowEnumItem.pkid, item.itemText, item.itemValue, this.nowEnumItem.sort, respon => {
						this.$dialogMethod.showMessage("更新字典项成功!")
						var enumitem = this.nowEnum.next.find(it => {
							return it.pkid == this.nowEnumItem.pkid
						})
						enumitem.itemText = item.itemText
						enumitem.itemValue = item.itemValue
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
		},
		 filters: {
			// 转换时间戳
			"date_format": function(value) { //value就是插值的数据
				if(!value) {
				return ""
				}
				let date=new Date(value);
				let Y=date.getFullYear()+'-';
				let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
				let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

				let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
				let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
				let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
				let strDate=Y+M+D+h+m+s;
				return strDate
			},
			}
	}
</script>

<style scoped lang="scss">
.newenumsetting {
	.con {
		 width: 100%;
		 height: 100%;
		 display: flex;
		 .set-left {
			
			height: 100%;
		 }
		 .set-title-top {
				display: flex;
				justify-content: space-between;
				align-items: center;
				/deep/.el-button {
					margin-right: 0px !important;
						padding: 6px 11px;
				}
			}
			.set-left .item {
				position: relative;
			}
			.is-btn {
				position: absolute;
				top: 50%;
				transform: translateY(-70%);
				right: 10px;
				display: none;
			}
			.set-caozuo {
				display: flex;
			}
			.set-left .item:hover{
				color: #1a1a1a;
				.is-btn {
					display: block;
				}
			}

	}
	 .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
      }
	.right-table {
		width: calc(100% - 275px);
		height: 100%;
       .top-table {
			width: 100%;
			height: 173px;
			background-color: #fff;
			padding: 12px 20px;
			box-sizing: border-box;
			margin-bottom: 8px;
	   }
	   .bot-table {
		  width: 100%;
		  height: calc(100% - 181px);
		  background-color: #fff;
		  padding: 12px 20px;
		  box-sizing: border-box;
	   }
	}


	   /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }
	/deep/.el-dialog {
		width: 450px !important;
		.el-input__inner {
			width: 240px;
		}
	}

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }
}
	
</style>
